const setCountry = (id = null, val = null) => {
  return {
    type: 'SET_COUNTRY',
    id,
    data: val,
  }
}

export default {
  setCountry,
}
